import { useParams } from 'react-router-dom-v5-compat'
import GuidesNav from '../../components/GuidesNav'
import { useGuidesConfig, useTopicNavigation } from '../../utils/useQueries'
import TopicView from '../../components/TopicView'
import PostViewAdapter from '../../components/PostViewAdapter/PostViewAdapter'
import PostListView from '../../components/PostListView'

const SlugRouter: React.FC = () => {
  const { slug } = useParams()
  const { emailUrls } = useGuidesConfig()
  const topicNavigation = useTopicNavigation()
  const topicRoutes: string[] = []

  topicNavigation.items.forEach((topic) => {
    topicRoutes.push(topic.slug)
    topic.children?.forEach((child) => {
      topicRoutes.push(child.slug)
    })
  })

  return (
    <>
      <GuidesNav />
      {slug && (
        <>
          {topicRoutes.includes(slug) ? (
            <PostListView>
              <TopicView emailUrls={emailUrls} slug={slug} />
            </PostListView>
          ) : (
            <PostViewAdapter emailUrls={emailUrls} slug={slug} />
          )}
        </>
      )}
    </>
  )
}

export default SlugRouter
